import { render, staticRenderFns } from "./CambioEstadoActivo.vue?vue&type=template&id=4fe86ae8"
import script from "./CambioEstadoActivo.vue?vue&type=script&lang=js"
export * from "./CambioEstadoActivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports